import * as Input from "@npco/zeller-design-system/input";
import { useCallback, useState } from "react";
import { twMerge } from "tailwind-merge";

export const InputCurrency = ({
	className,
	error,
	label,
	name,
	onBlur,
	onChange,
	symbol,
	value,
}: {
	error?: string | boolean;
	label: string;
	symbol?: string;
	name: string;
	onBlur?: () => void;
	onChange: (value: number) => void;
	value?: number;
	className?: string;
}) => {
	const [inputValue, setInputValue] = useState<string>(formatInput(value));

	const handleChange = useCallback(
		(value: string | undefined) => {
			if (value && isNaN(Number(value))) {
				return;
			}

			setInputValue(value ?? "");
			onChange(Math.round(Number(value) * 100));
		},
		[onChange],
	);

	const handleBlur = useCallback(() => {
		onBlur?.();
		setInputValue(formatInput(value));
	}, [onBlur, value]);

	return (
		<Input.Text
			className={twMerge("pt-16", className)}
			error={error}
			icon={<span className="text-grey-550">{symbol}</span>}
			label={label}
			name={name}
			onBlur={handleBlur}
			onChange={handleChange}
			value={inputValue}
			$input={{
				inputMode: "numeric",
				pattern: "[0-9]*",
			}}
		/>
	);
};

function formatInput(value: number | undefined) {
	return value
		? (value / 100).toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			})
		: "";
}
